import { ParamMap, Params } from '@angular/router';
import { IBase } from 'src/app/models';
import { ExpeditionStatus, ExpeditionType } from 'src/app/models/enums';
import {
  hasAnyFilterKey,
  parseEnumList,
  parseId,
  parseIdList,
  serializeIdList,
  serializeStringList,
} from './filterUtils';

export interface ITripsFilters {
  selectedClients: IBase[];
  selectedOperators: IBase[];
  selectedTowns: IBase[];
  selectedServices: IBase[];
  selectedRoutes: IBase[];
  selectedTypes: ExpeditionType[];
  selectedStatus: ExpeditionStatus[];
  selectedAvailabilityId: number | null;
}

export const TRIP_FILTER_KEYS = [
  'clients', 'operators', 'towns', 'services', 'routes', 'types', 'status', 'availability'
] as const;

export const DEFAULT_TRIP_STATUS: ExpeditionStatus[] = [
  ExpeditionStatus.OPEN, ExpeditionStatus.READY, ExpeditionStatus.ONGOING
];

export function serializeTripsFilters(f: ITripsFilters): Params {
  return {
    clients: serializeIdList(f.selectedClients),
    operators: serializeIdList(f.selectedOperators),
    towns: serializeIdList(f.selectedTowns),
    services: serializeIdList(f.selectedServices),
    routes: serializeIdList(f.selectedRoutes),
    types: serializeStringList(f.selectedTypes),
    status: serializeStringList(f.selectedStatus),
    availability: f.selectedAvailabilityId ?? null,
  };
}

export function deserializeTripsFilters(
  params: ParamMap,
  fallback?: ITripsFilters
): ITripsFilters {
  if (!hasAnyFilterKey(params, TRIP_FILTER_KEYS) && fallback) return fallback;

  return {
    selectedClients: parseIdList(params.get('clients'), fallback?.selectedClients),
    selectedOperators: parseIdList(params.get('operators'), fallback?.selectedOperators),
    selectedTowns: parseIdList(params.get('towns'), fallback?.selectedTowns),
    selectedServices: parseIdList(params.get('services'), fallback?.selectedServices),
    selectedRoutes: parseIdList(params.get('routes'), fallback?.selectedRoutes),
    selectedTypes: parseEnumList<ExpeditionType>(params.get('types')),
    selectedStatus: parseEnumList<ExpeditionStatus>(params.get('status'),
      fallback?.selectedStatus ?? DEFAULT_TRIP_STATUS),
    selectedAvailabilityId: parseId(params.get('availability')),
  };
}

export function parseTripsFiltersFromStorage(json: string | null | undefined): ITripsFilters | null {
  if (!json) return null;
  try {
    const f = JSON.parse(json);
    const nn = <T>(arr: T[] | null | undefined): T[] => (arr ?? []).filter((x) => x != null);
    return {
      selectedClients: nn(f.selectedClients),
      selectedOperators: nn(f.selectedOperators),
      selectedTowns: nn(f.selectedTowns),
      selectedServices: nn(f.selectedServices),
      selectedRoutes: nn(f.selectedRoutes),
      selectedTypes: nn(f.selectedTypes),
      selectedStatus: f.selectedStatus?.length ? f.selectedStatus : DEFAULT_TRIP_STATUS,
      selectedAvailabilityId: null,
    };
  } catch {
    return null;
  }
}
